import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import ClusterTable from "./ClusterTable";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const ApexChartComponent = () => {
  const navigate = useNavigate();
  const [view, setView] = useState(false);
  const [percentages, setPercentages] = useState([]); // Array to hold percentages for each 'out' cluster
  const [apexChartData, setApexChartData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [totalRecord, settotalRecord] = useState(null);
  const [totalPage, settotalPage] = useState(null);

  const handleNavigateToInfo = () => navigate("/consumption-inc-cluster");
  const handleNavigateToPrev = () => navigate("/data-segmentation");
  const handleNavigateToNext = () => navigate("/consumption-inc-cluster");

  console.log(
    "currentPagecurrentPage_insights",
    currentPage,
    pageSize,
    totalRecord,
    totalPage
  );

  useEffect(() => {
    Papa.parse("/merged_data_sum_normalized.csv", {
      download: true,
      header: true,
      complete: (result) => {
        if (result.data && result.data.length > 0) {
          const consColumns = Object.keys(result.data[0]).filter((key) =>
            key.startsWith("CONS")
          );

          const labels = consColumns.map((col) => col.replace("CONS_", ""));

          const seriesData = result.data
            .filter((row) => row.out) // Ensure the row contains 'out' data
            .map((row) => {
              const dataValues = consColumns.map((col) =>
                parseFloat(parseFloat(row[col]).toFixed(1))
              );

              return {
                name: `Cluster ${row.out}`,
                data: dataValues,
                lastValue: dataValues[dataValues.length - 1],
              };
            });

          setApexChartData({
            options: {
              chart: {
                id: "apexchart-example",
                toolbar: { show: false },
                title: {
                  text: "Cluster Consumption",
                  align: "center",
                  style: { fontSize: "18px" },
                },
              },
              xaxis: {
                categories: labels,
                title: {
                  text: "PERIOD",
                },
              },
              yaxis: {
                title: {
                  text: "CONSUMPTION",
                },
              },

              markers: { size: 4, colors: ["#FF4560"] },
            },
            series: seriesData,
          });
        }
      },
    });
  }, []);

  useEffect(() => {
    // Fetch and parse percentages from all_data_summary.csv
    const fetchSummaryData = async () => {
      try {
        const response = await fetch("/all_data_summary.csv");

        const text = await response.text();
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const parsedData = results.data;
            // Map the percentage values to the 'out' clusters
            const percentageValues = parsedData.map((row) =>
              parseFloat(row.percentage || 0).toFixed(2)
            );
            setPercentages(percentageValues);
          },
          error: (error) => {
            console.error("Error parsing all_data_summary.csv:", error);
          },
        });
      } catch (error) {
        console.error("Error fetching all_data_summary.csv:", error);
      }
    };

    fetchSummaryData();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* ...Progress bar and navigation buttons... */}

        <div className="page-header">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="progress-steps">
                  <div className="progress-item">
                    <div className="progress-circle bg-success"></div>
                    <p className="progress-label">Data Collection</p>
                  </div>
                  <div className="progress-item">
                    <div className="progress-circle bg-success"></div>
                    <p className="progress-label">Data Processing</p>
                  </div>
                  <div className="progress-item">
                    <div className="progress-circle bg-success"></div>
                    <p className="progress-label">Segmentation</p>
                  </div>
                  <div className="progress-item">
                    <div className="progress-circle bg-success"></div>
                    <p className="progress-label">Results</p>
                  </div>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-success"
                    style={{ width: "100%" }}
                    role="progressbar"
                    aria-valuenow={70}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="d-flex justify-content-end"
          style={{ paddingRight: "30px", marginBottom: "20px" }}
        >
          <button
            className="btn btn-primary"
            onClick={() => {
              setView(!view);
              if (!view) {
                setTimeout(() => {
                  window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: "smooth",
                  });
                }, 100);
              }
            }}
          >
            {view ? "Hide Table" : "View Table"}
          </button>
          <button
            className="btn btn-success ms-2"
            type="button"
            onClick={handleNavigateToInfo}
          >
            Insights
          </button>
        </div>

        <div className="container">
          <div className="row">
            {apexChartData.series &&
              apexChartData.series.map((series, index) => {
                const percentage = percentages[index];
                return (
                  <div className="col-md-3" key={index}>
                    <h5>
                      {series.name}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Consumers:
                      &nbsp;
                      {percentages[index]} %
                    </h5>
                    <Chart
                      options={{
                        ...apexChartData.options,
                      }}
                      series={[series]}
                      type="line"
                      height={300}
                    />
                  </div>
                );
              })}
          </div>

          {view && (
            <ClusterTable
              currentPage={currentPage}
              // pageSize={pageSize}
              // totalRecord={totalRecord}
              // totalPage={totalPage}
              setCurrentPage={setCurrentPage}
              title="insight"
            />
          )}

          <div className="mt-2 d-flex justify-content-between">
            <button className="prev-button" onClick={handleNavigateToPrev}>
              <FaArrowLeft style={{ marginRight: "8px" }} />
              Previous Step
            </button>
            <button className="next-button" onClick={handleNavigateToNext}>
              Next Step <FaArrowRight style={{ marginLeft: "8px" }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApexChartComponent;
